//----------------------
// <auto-generated>
//     Generated using the NSwag toolchain v14.5.0.0 (NJsonSchema v11.4.0.0 (Newtonsoft.Json v13.0.0.0)) (http://NSwag.org)
// </auto-generated>
//----------------------

/* eslint-disable */
// ReSharper disable InconsistentNaming

import axios, { AxiosError, type AxiosInstance, type AxiosRequestConfig, type AxiosResponse, type CancelToken } from 'axios';

export class EOtpLoginClient {
    protected instance: AxiosInstance;
    protected baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        this.instance = instance || axios.create();

        this.baseUrl = baseUrl ?? "";

    }

    /**
     * @param body (optional) 
     * @return Success
     */
    send(otpType: OtpType, authenticationSchemeId: string, tenantPublicId: string, signFlowId: string, signatureId: string, signatureRequestType: SignatureRequestType, body: string | undefined, cancelToken?: CancelToken): Promise<SendEmailResultCode> {
        let url_ = this.baseUrl + "/api/{TenantPublicId}/otplogin/{otpType}/{authenticationSchemeId}/{SignFlowId}/{SignatureRequestType}/{SignatureId}/send";
        if (otpType === undefined || otpType === null)
            throw new globalThis.Error("The parameter 'otpType' must be defined.");
        url_ = url_.replace("{otpType}", encodeURIComponent("" + otpType));
        if (authenticationSchemeId === undefined || authenticationSchemeId === null)
            throw new globalThis.Error("The parameter 'authenticationSchemeId' must be defined.");
        url_ = url_.replace("{authenticationSchemeId}", encodeURIComponent("" + authenticationSchemeId));
        if (tenantPublicId === undefined || tenantPublicId === null)
            throw new globalThis.Error("The parameter 'tenantPublicId' must be defined.");
        url_ = url_.replace("{TenantPublicId}", encodeURIComponent("" + tenantPublicId));
        if (signFlowId === undefined || signFlowId === null)
            throw new globalThis.Error("The parameter 'signFlowId' must be defined.");
        url_ = url_.replace("{SignFlowId}", encodeURIComponent("" + signFlowId));
        if (signatureId === undefined || signatureId === null)
            throw new globalThis.Error("The parameter 'signatureId' must be defined.");
        url_ = url_.replace("{SignatureId}", encodeURIComponent("" + signatureId));
        if (signatureRequestType === undefined || signatureRequestType === null)
            throw new globalThis.Error("The parameter 'signatureRequestType' must be defined.");
        url_ = url_.replace("{SignatureRequestType}", encodeURIComponent("" + signatureRequestType));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processSend(_response);
        });
    }

    protected processSend(response: AxiosResponse): Promise<SendEmailResultCode> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
                result200 = resultData200 !== undefined ? resultData200 : null as any;
    
            return Promise.resolve<SendEmailResultCode>(result200);

        } else if (status === 400) {
            const _responseText = response.data;
            return throwException("Bad Request", status, _responseText, _headers);

        } else if (status === 401) {
            const _responseText = response.data;
            return throwException("Unauthorized", status, _responseText, _headers);

        } else if (status === 404) {
            const _responseText = response.data;
            return throwException("Not Found", status, _responseText, _headers);

        } else if (status === 419) {
            const _responseText = response.data;
            return throwException("Authorization Timeout", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<SendEmailResultCode>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    validateCode(otpType: OtpType, authenticationSchemeId: string, tenantPublicId: string, signFlowId: string, signatureId: string, signatureRequestType: SignatureRequestType, body: string | undefined, cancelToken?: CancelToken): Promise<ValidateCodeResponse> {
        let url_ = this.baseUrl + "/api/{TenantPublicId}/otplogin/{otpType}/{authenticationSchemeId}/{SignFlowId}/{SignatureRequestType}/{SignatureId}/validatecode";
        if (otpType === undefined || otpType === null)
            throw new globalThis.Error("The parameter 'otpType' must be defined.");
        url_ = url_.replace("{otpType}", encodeURIComponent("" + otpType));
        if (authenticationSchemeId === undefined || authenticationSchemeId === null)
            throw new globalThis.Error("The parameter 'authenticationSchemeId' must be defined.");
        url_ = url_.replace("{authenticationSchemeId}", encodeURIComponent("" + authenticationSchemeId));
        if (tenantPublicId === undefined || tenantPublicId === null)
            throw new globalThis.Error("The parameter 'tenantPublicId' must be defined.");
        url_ = url_.replace("{TenantPublicId}", encodeURIComponent("" + tenantPublicId));
        if (signFlowId === undefined || signFlowId === null)
            throw new globalThis.Error("The parameter 'signFlowId' must be defined.");
        url_ = url_.replace("{SignFlowId}", encodeURIComponent("" + signFlowId));
        if (signatureId === undefined || signatureId === null)
            throw new globalThis.Error("The parameter 'signatureId' must be defined.");
        url_ = url_.replace("{SignatureId}", encodeURIComponent("" + signatureId));
        if (signatureRequestType === undefined || signatureRequestType === null)
            throw new globalThis.Error("The parameter 'signatureRequestType' must be defined.");
        url_ = url_.replace("{SignatureRequestType}", encodeURIComponent("" + signatureRequestType));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processValidateCode(_response);
        });
    }

    protected processValidateCode(response: AxiosResponse): Promise<ValidateCodeResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = ValidateCodeResponse.fromJS(resultData200);
            return Promise.resolve<ValidateCodeResponse>(result200);

        } else if (status === 400) {
            const _responseText = response.data;
            return throwException("Bad Request", status, _responseText, _headers);

        } else if (status === 401) {
            const _responseText = response.data;
            return throwException("Unauthorized", status, _responseText, _headers);

        } else if (status === 404) {
            const _responseText = response.data;
            return throwException("Not Found", status, _responseText, _headers);

        } else if (status === 419) {
            const _responseText = response.data;
            return throwException("Authorization Timeout", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ValidateCodeResponse>(null as any);
    }
}

export class ESchemeClient {
    protected instance: AxiosInstance;
    protected baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        this.instance = instance || axios.create();

        this.baseUrl = baseUrl ?? "";

    }

    /**
     * @return Success
     */
    authenticationMethodsForSignature(tenantPublicId: string, signFlowId: string, signatureId: string, signatureRequestType: SignatureRequestType, cancelToken?: CancelToken): Promise<AuthenticationMethod[]> {
        let url_ = this.baseUrl + "/api/{TenantPublicId}/Scheme/authenticationmethods/{SignFlowId}/{SignatureRequestType}/{SignatureId}";
        if (tenantPublicId === undefined || tenantPublicId === null)
            throw new globalThis.Error("The parameter 'tenantPublicId' must be defined.");
        url_ = url_.replace("{TenantPublicId}", encodeURIComponent("" + tenantPublicId));
        if (signFlowId === undefined || signFlowId === null)
            throw new globalThis.Error("The parameter 'signFlowId' must be defined.");
        url_ = url_.replace("{SignFlowId}", encodeURIComponent("" + signFlowId));
        if (signatureId === undefined || signatureId === null)
            throw new globalThis.Error("The parameter 'signatureId' must be defined.");
        url_ = url_.replace("{SignatureId}", encodeURIComponent("" + signatureId));
        if (signatureRequestType === undefined || signatureRequestType === null)
            throw new globalThis.Error("The parameter 'signatureRequestType' must be defined.");
        url_ = url_.replace("{SignatureRequestType}", encodeURIComponent("" + signatureRequestType));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processAuthenticationMethodsForSignature(_response);
        });
    }

    protected processAuthenticationMethodsForSignature(response: AxiosResponse): Promise<AuthenticationMethod[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(AuthenticationMethod.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return Promise.resolve<AuthenticationMethod[]>(result200);

        } else if (status === 400) {
            const _responseText = response.data;
            return throwException("Bad Request", status, _responseText, _headers);

        } else if (status === 401) {
            const _responseText = response.data;
            return throwException("Unauthorized", status, _responseText, _headers);

        } else if (status === 404) {
            const _responseText = response.data;
            return throwException("Not Found", status, _responseText, _headers);

        } else if (status === 419) {
            const _responseText = response.data;
            return throwException("Authorization Timeout", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<AuthenticationMethod[]>(null as any);
    }
}

export class EScsClient {
    protected instance: AxiosInstance;
    protected baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        this.instance = instance || axios.create();

        this.baseUrl = baseUrl ?? "";

    }

    /**
     * @return Success
     */
    getChallenge(tenantPublicId: string, cancelToken?: CancelToken): Promise<string> {
        let url_ = this.baseUrl + "/api/{TenantPublicId}/scslogin/challenge";
        if (tenantPublicId === undefined || tenantPublicId === null)
            throw new globalThis.Error("The parameter 'tenantPublicId' must be defined.");
        url_ = url_.replace("{TenantPublicId}", encodeURIComponent("" + tenantPublicId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "POST",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetChallenge(_response);
        });
    }

    protected processGetChallenge(response: AxiosResponse): Promise<string> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
                result200 = resultData200 !== undefined ? resultData200 : null as any;
    
            return Promise.resolve<string>(result200);

        } else if (status === 400) {
            const _responseText = response.data;
            return throwException("Bad Request", status, _responseText, _headers);

        } else if (status === 401) {
            const _responseText = response.data;
            return throwException("Unauthorized", status, _responseText, _headers);

        } else if (status === 404) {
            const _responseText = response.data;
            return throwException("Not Found", status, _responseText, _headers);

        } else if (status === 419) {
            const _responseText = response.data;
            return throwException("Authorization Timeout", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<string>(null as any);
    }

    /**
     * Handle postback from SCS login
     * @param body (optional) 
     * @return Success
     */
    scsLogin(tenantPublicId: string, signFlowId: string, signatureId: string, signatureRequestType: SignatureRequestType, schemeId: string, body: string | undefined, cancelToken?: CancelToken): Promise<AuthenticationOkResponse> {
        let url_ = this.baseUrl + "/api/{TenantPublicId}/scslogin/login/{schemeId}/{SignFlowId}/{SignatureRequestType}/{SignatureId}";
        if (tenantPublicId === undefined || tenantPublicId === null)
            throw new globalThis.Error("The parameter 'tenantPublicId' must be defined.");
        url_ = url_.replace("{TenantPublicId}", encodeURIComponent("" + tenantPublicId));
        if (signFlowId === undefined || signFlowId === null)
            throw new globalThis.Error("The parameter 'signFlowId' must be defined.");
        url_ = url_.replace("{SignFlowId}", encodeURIComponent("" + signFlowId));
        if (signatureId === undefined || signatureId === null)
            throw new globalThis.Error("The parameter 'signatureId' must be defined.");
        url_ = url_.replace("{SignatureId}", encodeURIComponent("" + signatureId));
        if (signatureRequestType === undefined || signatureRequestType === null)
            throw new globalThis.Error("The parameter 'signatureRequestType' must be defined.");
        url_ = url_.replace("{SignatureRequestType}", encodeURIComponent("" + signatureRequestType));
        if (schemeId === undefined || schemeId === null)
            throw new globalThis.Error("The parameter 'schemeId' must be defined.");
        url_ = url_.replace("{schemeId}", encodeURIComponent("" + schemeId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processScsLogin(_response);
        });
    }

    protected processScsLogin(response: AxiosResponse): Promise<AuthenticationOkResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = AuthenticationOkResponse.fromJS(resultData200);
            return Promise.resolve<AuthenticationOkResponse>(result200);

        } else if (status === 400) {
            const _responseText = response.data;
            return throwException("Bad Request", status, _responseText, _headers);

        } else if (status === 401) {
            const _responseText = response.data;
            return throwException("Unauthorized", status, _responseText, _headers);

        } else if (status === 404) {
            const _responseText = response.data;
            return throwException("Not Found", status, _responseText, _headers);

        } else if (status === 419) {
            const _responseText = response.data;
            return throwException("Authorization Timeout", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<AuthenticationOkResponse>(null as any);
    }
}

export class ESignClient {
    protected instance: AxiosInstance;
    protected baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        this.instance = instance || axios.create();

        this.baseUrl = baseUrl ?? "";

    }

    /**
     * List a signflow's signfiles
     * @return Success
     */
    listSignFiles(tenantPublicId: string, signFlowId: string, signatureId: string, signatureRequestType: SignatureRequestType, cancelToken?: CancelToken): Promise<string[]> {
        let url_ = this.baseUrl + "/api/{TenantPublicId}/signflows/v2/{SignFlowId}/{SignatureRequestType}/{SignatureId}/signfiles";
        if (tenantPublicId === undefined || tenantPublicId === null)
            throw new globalThis.Error("The parameter 'tenantPublicId' must be defined.");
        url_ = url_.replace("{TenantPublicId}", encodeURIComponent("" + tenantPublicId));
        if (signFlowId === undefined || signFlowId === null)
            throw new globalThis.Error("The parameter 'signFlowId' must be defined.");
        url_ = url_.replace("{SignFlowId}", encodeURIComponent("" + signFlowId));
        if (signatureId === undefined || signatureId === null)
            throw new globalThis.Error("The parameter 'signatureId' must be defined.");
        url_ = url_.replace("{SignatureId}", encodeURIComponent("" + signatureId));
        if (signatureRequestType === undefined || signatureRequestType === null)
            throw new globalThis.Error("The parameter 'signatureRequestType' must be defined.");
        url_ = url_.replace("{SignatureRequestType}", encodeURIComponent("" + signatureRequestType));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processListSignFiles(_response);
        });
    }

    protected processListSignFiles(response: AxiosResponse): Promise<string[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(item);
            }
            else {
                result200 = null as any;
            }
            return Promise.resolve<string[]>(result200);

        } else if (status === 400) {
            const _responseText = response.data;
            return throwException("Bad Request", status, _responseText, _headers);

        } else if (status === 401) {
            const _responseText = response.data;
            return throwException("Unauthorized", status, _responseText, _headers);

        } else if (status === 404) {
            const _responseText = response.data;
            return throwException("Not Found", status, _responseText, _headers);

        } else if (status === 419) {
            const _responseText = response.data;
            return throwException("Authorization Timeout", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<string[]>(null as any);
    }

    /**
     * List a signflow's attachments
     * @return Success
     */
    listAttachments(tenantPublicId: string, signFlowId: string, signatureId: string, signatureRequestType: SignatureRequestType, cancelToken?: CancelToken): Promise<Attachment[]> {
        let url_ = this.baseUrl + "/api/{TenantPublicId}/signflows/v2/{SignFlowId}/{SignatureRequestType}/{SignatureId}/attachments";
        if (tenantPublicId === undefined || tenantPublicId === null)
            throw new globalThis.Error("The parameter 'tenantPublicId' must be defined.");
        url_ = url_.replace("{TenantPublicId}", encodeURIComponent("" + tenantPublicId));
        if (signFlowId === undefined || signFlowId === null)
            throw new globalThis.Error("The parameter 'signFlowId' must be defined.");
        url_ = url_.replace("{SignFlowId}", encodeURIComponent("" + signFlowId));
        if (signatureId === undefined || signatureId === null)
            throw new globalThis.Error("The parameter 'signatureId' must be defined.");
        url_ = url_.replace("{SignatureId}", encodeURIComponent("" + signatureId));
        if (signatureRequestType === undefined || signatureRequestType === null)
            throw new globalThis.Error("The parameter 'signatureRequestType' must be defined.");
        url_ = url_.replace("{SignatureRequestType}", encodeURIComponent("" + signatureRequestType));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processListAttachments(_response);
        });
    }

    protected processListAttachments(response: AxiosResponse): Promise<Attachment[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(Attachment.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return Promise.resolve<Attachment[]>(result200);

        } else if (status === 400) {
            const _responseText = response.data;
            return throwException("Bad Request", status, _responseText, _headers);

        } else if (status === 401) {
            const _responseText = response.data;
            return throwException("Unauthorized", status, _responseText, _headers);

        } else if (status === 404) {
            const _responseText = response.data;
            return throwException("Not Found", status, _responseText, _headers);

        } else if (status === 419) {
            const _responseText = response.data;
            return throwException("Authorization Timeout", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<Attachment[]>(null as any);
    }

    /**
     * Get signing info details
     * @return Success
     */
    getSigningInfoDetails(tenantPublicId: string, signFlowId: string, signatureId: string, signatureRequestType: SignatureRequestType, cancelToken?: CancelToken): Promise<SigningInfoDetails> {
        let url_ = this.baseUrl + "/api/{TenantPublicId}/signflows/v2/{SignFlowId}/{SignatureRequestType}/{SignatureId}/signinginfo";
        if (tenantPublicId === undefined || tenantPublicId === null)
            throw new globalThis.Error("The parameter 'tenantPublicId' must be defined.");
        url_ = url_.replace("{TenantPublicId}", encodeURIComponent("" + tenantPublicId));
        if (signFlowId === undefined || signFlowId === null)
            throw new globalThis.Error("The parameter 'signFlowId' must be defined.");
        url_ = url_.replace("{SignFlowId}", encodeURIComponent("" + signFlowId));
        if (signatureId === undefined || signatureId === null)
            throw new globalThis.Error("The parameter 'signatureId' must be defined.");
        url_ = url_.replace("{SignatureId}", encodeURIComponent("" + signatureId));
        if (signatureRequestType === undefined || signatureRequestType === null)
            throw new globalThis.Error("The parameter 'signatureRequestType' must be defined.");
        url_ = url_.replace("{SignatureRequestType}", encodeURIComponent("" + signatureRequestType));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetSigningInfoDetails(_response);
        });
    }

    protected processGetSigningInfoDetails(response: AxiosResponse): Promise<SigningInfoDetails> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = SigningInfoDetails.fromJS(resultData200);
            return Promise.resolve<SigningInfoDetails>(result200);

        } else if (status === 400) {
            const _responseText = response.data;
            return throwException("Bad Request", status, _responseText, _headers);

        } else if (status === 401) {
            const _responseText = response.data;
            return throwException("Unauthorized", status, _responseText, _headers);

        } else if (status === 404) {
            const _responseText = response.data;
            return throwException("Not Found", status, _responseText, _headers);

        } else if (status === 419) {
            const _responseText = response.data;
            return throwException("Authorization Timeout", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<SigningInfoDetails>(null as any);
    }

    /**
     * Get a signature's metadata
     * @return Success
     */
    getSignature(tenantPublicId: string, signFlowId: string, signatureId: string, signatureRequestType: SignatureRequestType, cancelToken?: CancelToken): Promise<SignatureRequest> {
        let url_ = this.baseUrl + "/api/{TenantPublicId}/signflows/v2/{SignFlowId}/{SignatureRequestType}/{SignatureId}/signatures";
        if (tenantPublicId === undefined || tenantPublicId === null)
            throw new globalThis.Error("The parameter 'tenantPublicId' must be defined.");
        url_ = url_.replace("{TenantPublicId}", encodeURIComponent("" + tenantPublicId));
        if (signFlowId === undefined || signFlowId === null)
            throw new globalThis.Error("The parameter 'signFlowId' must be defined.");
        url_ = url_.replace("{SignFlowId}", encodeURIComponent("" + signFlowId));
        if (signatureId === undefined || signatureId === null)
            throw new globalThis.Error("The parameter 'signatureId' must be defined.");
        url_ = url_.replace("{SignatureId}", encodeURIComponent("" + signatureId));
        if (signatureRequestType === undefined || signatureRequestType === null)
            throw new globalThis.Error("The parameter 'signatureRequestType' must be defined.");
        url_ = url_.replace("{SignatureRequestType}", encodeURIComponent("" + signatureRequestType));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetSignature(_response);
        });
    }

    protected processGetSignature(response: AxiosResponse): Promise<SignatureRequest> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = SignatureRequest.fromJS(resultData200);
            return Promise.resolve<SignatureRequest>(result200);

        } else if (status === 400) {
            const _responseText = response.data;
            return throwException("Bad Request", status, _responseText, _headers);

        } else if (status === 401) {
            const _responseText = response.data;
            return throwException("Unauthorized", status, _responseText, _headers);

        } else if (status === 404) {
            const _responseText = response.data;
            return throwException("Not Found", status, _responseText, _headers);

        } else if (status === 419) {
            const _responseText = response.data;
            return throwException("Authorization Timeout", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<SignatureRequest>(null as any);
    }

    /**
     * Mark a signflow signed by one of its signers
     * @param body (optional) 
     * @return Success
     */
    uploadSignature(tenantPublicId: string, signFlowId: string, signatureId: string, signatureRequestType: SignatureRequestType, body: UploadSignatureModel | undefined, cancelToken?: CancelToken): Promise<void> {
        let url_ = this.baseUrl + "/api/{TenantPublicId}/signflows/v2/{SignFlowId}/{SignatureRequestType}/{SignatureId}/signatures";
        if (tenantPublicId === undefined || tenantPublicId === null)
            throw new globalThis.Error("The parameter 'tenantPublicId' must be defined.");
        url_ = url_.replace("{TenantPublicId}", encodeURIComponent("" + tenantPublicId));
        if (signFlowId === undefined || signFlowId === null)
            throw new globalThis.Error("The parameter 'signFlowId' must be defined.");
        url_ = url_.replace("{SignFlowId}", encodeURIComponent("" + signFlowId));
        if (signatureId === undefined || signatureId === null)
            throw new globalThis.Error("The parameter 'signatureId' must be defined.");
        url_ = url_.replace("{SignatureId}", encodeURIComponent("" + signatureId));
        if (signatureRequestType === undefined || signatureRequestType === null)
            throw new globalThis.Error("The parameter 'signatureRequestType' must be defined.");
        url_ = url_.replace("{SignatureRequestType}", encodeURIComponent("" + signatureRequestType));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processUploadSignature(_response);
        });
    }

    protected processUploadSignature(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status === 400) {
            const _responseText = response.data;
            return throwException("Bad Request", status, _responseText, _headers);

        } else if (status === 401) {
            const _responseText = response.data;
            return throwException("Unauthorized", status, _responseText, _headers);

        } else if (status === 404) {
            const _responseText = response.data;
            return throwException("Not Found", status, _responseText, _headers);

        } else if (status === 419) {
            const _responseText = response.data;
            return throwException("Authorization Timeout", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * Download a signfile (API)
     * @return Success
     */
    downloadSignFileGET(tenantPublicId: string, signFlowId: string, signatureId: string, signatureRequestType: SignatureRequestType, signFileId: string, status: SignFileStatus, cancelToken?: CancelToken): Promise<FileResponse> {
        let url_ = this.baseUrl + "/api/{TenantPublicId}/signflows/v2/{SignFlowId}/{SignatureRequestType}/{SignatureId}/signfiles/{signFileId}/{status}";
        if (tenantPublicId === undefined || tenantPublicId === null)
            throw new globalThis.Error("The parameter 'tenantPublicId' must be defined.");
        url_ = url_.replace("{TenantPublicId}", encodeURIComponent("" + tenantPublicId));
        if (signFlowId === undefined || signFlowId === null)
            throw new globalThis.Error("The parameter 'signFlowId' must be defined.");
        url_ = url_.replace("{SignFlowId}", encodeURIComponent("" + signFlowId));
        if (signatureId === undefined || signatureId === null)
            throw new globalThis.Error("The parameter 'signatureId' must be defined.");
        url_ = url_.replace("{SignatureId}", encodeURIComponent("" + signatureId));
        if (signatureRequestType === undefined || signatureRequestType === null)
            throw new globalThis.Error("The parameter 'signatureRequestType' must be defined.");
        url_ = url_.replace("{SignatureRequestType}", encodeURIComponent("" + signatureRequestType));
        if (signFileId === undefined || signFileId === null)
            throw new globalThis.Error("The parameter 'signFileId' must be defined.");
        url_ = url_.replace("{signFileId}", encodeURIComponent("" + signFileId));
        if (status === undefined || status === null)
            throw new globalThis.Error("The parameter 'status' must be defined.");
        url_ = url_.replace("{status}", encodeURIComponent("" + status));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            responseType: "blob",
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/pdf"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processDownloadSignFileGET(_response);
        });
    }

    protected processDownloadSignFileGET(response: AxiosResponse): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers["content-disposition"] : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return Promise.resolve({ fileName: fileName, status: status, data: new Blob([response.data], { type: response.headers["content-type"] }), headers: _headers });
        } else if (status === 400) {
            const _responseText = response.data;
            return throwException("Bad Request", status, _responseText, _headers);

        } else if (status === 401) {
            const _responseText = response.data;
            return throwException("Unauthorized", status, _responseText, _headers);

        } else if (status === 404) {
            const _responseText = response.data;
            return throwException("Not Found", status, _responseText, _headers);

        } else if (status === 419) {
            const _responseText = response.data;
            return throwException("Authorization Timeout", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<FileResponse>(null as any);
    }

    /**
     * Download a signfile (API)
     * @return Success
     */
    downloadSignFileHEAD(tenantPublicId: string, signFlowId: string, signatureId: string, signatureRequestType: SignatureRequestType, signFileId: string, status: SignFileStatus, cancelToken?: CancelToken): Promise<FileResponse> {
        let url_ = this.baseUrl + "/api/{TenantPublicId}/signflows/v2/{SignFlowId}/{SignatureRequestType}/{SignatureId}/signfiles/{signFileId}/{status}";
        if (tenantPublicId === undefined || tenantPublicId === null)
            throw new globalThis.Error("The parameter 'tenantPublicId' must be defined.");
        url_ = url_.replace("{TenantPublicId}", encodeURIComponent("" + tenantPublicId));
        if (signFlowId === undefined || signFlowId === null)
            throw new globalThis.Error("The parameter 'signFlowId' must be defined.");
        url_ = url_.replace("{SignFlowId}", encodeURIComponent("" + signFlowId));
        if (signatureId === undefined || signatureId === null)
            throw new globalThis.Error("The parameter 'signatureId' must be defined.");
        url_ = url_.replace("{SignatureId}", encodeURIComponent("" + signatureId));
        if (signatureRequestType === undefined || signatureRequestType === null)
            throw new globalThis.Error("The parameter 'signatureRequestType' must be defined.");
        url_ = url_.replace("{SignatureRequestType}", encodeURIComponent("" + signatureRequestType));
        if (signFileId === undefined || signFileId === null)
            throw new globalThis.Error("The parameter 'signFileId' must be defined.");
        url_ = url_.replace("{signFileId}", encodeURIComponent("" + signFileId));
        if (status === undefined || status === null)
            throw new globalThis.Error("The parameter 'status' must be defined.");
        url_ = url_.replace("{status}", encodeURIComponent("" + status));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            responseType: "blob",
            method: "HEAD",
            url: url_,
            headers: {
                "Accept": "application/pdf"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processDownloadSignFileHEAD(_response);
        });
    }

    protected processDownloadSignFileHEAD(response: AxiosResponse): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers["content-disposition"] : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return Promise.resolve({ fileName: fileName, status: status, data: new Blob([response.data], { type: response.headers["content-type"] }), headers: _headers });
        } else if (status === 400) {
            const _responseText = response.data;
            return throwException("Bad Request", status, _responseText, _headers);

        } else if (status === 401) {
            const _responseText = response.data;
            return throwException("Unauthorized", status, _responseText, _headers);

        } else if (status === 404) {
            const _responseText = response.data;
            return throwException("Not Found", status, _responseText, _headers);

        } else if (status === 419) {
            const _responseText = response.data;
            return throwException("Authorization Timeout", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<FileResponse>(null as any);
    }

    /**
     * Download a signfile (browser)
     * @return Success
     */
    downloadSignFileBrowserGET(tenantPublicId: string, signFlowId: string, signatureId: string, signatureRequestType: SignatureRequestType, signFileId: string, cancelToken?: CancelToken): Promise<FileResponse> {
        let url_ = this.baseUrl + "/api/{TenantPublicId}/signflows/v2/{SignFlowId}/{SignatureRequestType}/{SignatureId}/signfiles/{signFileId}/download";
        if (tenantPublicId === undefined || tenantPublicId === null)
            throw new globalThis.Error("The parameter 'tenantPublicId' must be defined.");
        url_ = url_.replace("{TenantPublicId}", encodeURIComponent("" + tenantPublicId));
        if (signFlowId === undefined || signFlowId === null)
            throw new globalThis.Error("The parameter 'signFlowId' must be defined.");
        url_ = url_.replace("{SignFlowId}", encodeURIComponent("" + signFlowId));
        if (signatureId === undefined || signatureId === null)
            throw new globalThis.Error("The parameter 'signatureId' must be defined.");
        url_ = url_.replace("{SignatureId}", encodeURIComponent("" + signatureId));
        if (signatureRequestType === undefined || signatureRequestType === null)
            throw new globalThis.Error("The parameter 'signatureRequestType' must be defined.");
        url_ = url_.replace("{SignatureRequestType}", encodeURIComponent("" + signatureRequestType));
        if (signFileId === undefined || signFileId === null)
            throw new globalThis.Error("The parameter 'signFileId' must be defined.");
        url_ = url_.replace("{signFileId}", encodeURIComponent("" + signFileId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            responseType: "blob",
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/pdf"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processDownloadSignFileBrowserGET(_response);
        });
    }

    protected processDownloadSignFileBrowserGET(response: AxiosResponse): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers["content-disposition"] : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return Promise.resolve({ fileName: fileName, status: status, data: new Blob([response.data], { type: response.headers["content-type"] }), headers: _headers });
        } else if (status === 400) {
            const _responseText = response.data;
            return throwException("Bad Request", status, _responseText, _headers);

        } else if (status === 401) {
            const _responseText = response.data;
            return throwException("Unauthorized", status, _responseText, _headers);

        } else if (status === 404) {
            const _responseText = response.data;
            return throwException("Not Found", status, _responseText, _headers);

        } else if (status === 419) {
            const _responseText = response.data;
            return throwException("Authorization Timeout", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<FileResponse>(null as any);
    }

    /**
     * Download a signfile (browser)
     * @return Success
     */
    downloadSignFileBrowserHEAD(tenantPublicId: string, signFlowId: string, signatureId: string, signatureRequestType: SignatureRequestType, signFileId: string, cancelToken?: CancelToken): Promise<FileResponse> {
        let url_ = this.baseUrl + "/api/{TenantPublicId}/signflows/v2/{SignFlowId}/{SignatureRequestType}/{SignatureId}/signfiles/{signFileId}/download";
        if (tenantPublicId === undefined || tenantPublicId === null)
            throw new globalThis.Error("The parameter 'tenantPublicId' must be defined.");
        url_ = url_.replace("{TenantPublicId}", encodeURIComponent("" + tenantPublicId));
        if (signFlowId === undefined || signFlowId === null)
            throw new globalThis.Error("The parameter 'signFlowId' must be defined.");
        url_ = url_.replace("{SignFlowId}", encodeURIComponent("" + signFlowId));
        if (signatureId === undefined || signatureId === null)
            throw new globalThis.Error("The parameter 'signatureId' must be defined.");
        url_ = url_.replace("{SignatureId}", encodeURIComponent("" + signatureId));
        if (signatureRequestType === undefined || signatureRequestType === null)
            throw new globalThis.Error("The parameter 'signatureRequestType' must be defined.");
        url_ = url_.replace("{SignatureRequestType}", encodeURIComponent("" + signatureRequestType));
        if (signFileId === undefined || signFileId === null)
            throw new globalThis.Error("The parameter 'signFileId' must be defined.");
        url_ = url_.replace("{signFileId}", encodeURIComponent("" + signFileId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            responseType: "blob",
            method: "HEAD",
            url: url_,
            headers: {
                "Accept": "application/pdf"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processDownloadSignFileBrowserHEAD(_response);
        });
    }

    protected processDownloadSignFileBrowserHEAD(response: AxiosResponse): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers["content-disposition"] : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return Promise.resolve({ fileName: fileName, status: status, data: new Blob([response.data], { type: response.headers["content-type"] }), headers: _headers });
        } else if (status === 400) {
            const _responseText = response.data;
            return throwException("Bad Request", status, _responseText, _headers);

        } else if (status === 401) {
            const _responseText = response.data;
            return throwException("Unauthorized", status, _responseText, _headers);

        } else if (status === 404) {
            const _responseText = response.data;
            return throwException("Not Found", status, _responseText, _headers);

        } else if (status === 419) {
            const _responseText = response.data;
            return throwException("Authorization Timeout", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<FileResponse>(null as any);
    }

    /**
     * Check if zipfile is ready for download (browser)
     * @return Success
     */
    getZipStatus(tenantPublicId: string, signFlowId: string, signatureId: string, signatureRequestType: SignatureRequestType, cancelToken?: CancelToken): Promise<boolean> {
        let url_ = this.baseUrl + "/api/{TenantPublicId}/signflows/v2/{SignFlowId}/{SignatureRequestType}/{SignatureId}/zip/ready";
        if (tenantPublicId === undefined || tenantPublicId === null)
            throw new globalThis.Error("The parameter 'tenantPublicId' must be defined.");
        url_ = url_.replace("{TenantPublicId}", encodeURIComponent("" + tenantPublicId));
        if (signFlowId === undefined || signFlowId === null)
            throw new globalThis.Error("The parameter 'signFlowId' must be defined.");
        url_ = url_.replace("{SignFlowId}", encodeURIComponent("" + signFlowId));
        if (signatureId === undefined || signatureId === null)
            throw new globalThis.Error("The parameter 'signatureId' must be defined.");
        url_ = url_.replace("{SignatureId}", encodeURIComponent("" + signatureId));
        if (signatureRequestType === undefined || signatureRequestType === null)
            throw new globalThis.Error("The parameter 'signatureRequestType' must be defined.");
        url_ = url_.replace("{SignatureRequestType}", encodeURIComponent("" + signatureRequestType));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetZipStatus(_response);
        });
    }

    protected processGetZipStatus(response: AxiosResponse): Promise<boolean> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
                result200 = resultData200 !== undefined ? resultData200 : null as any;
    
            return Promise.resolve<boolean>(result200);

        } else if (status === 400) {
            const _responseText = response.data;
            return throwException("Bad Request", status, _responseText, _headers);

        } else if (status === 401) {
            const _responseText = response.data;
            return throwException("Unauthorized", status, _responseText, _headers);

        } else if (status === 404) {
            const _responseText = response.data;
            return throwException("Not Found", status, _responseText, _headers);

        } else if (status === 419) {
            const _responseText = response.data;
            return throwException("Authorization Timeout", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<boolean>(null as any);
    }

    /**
     * Download zip package of signfile and attachments (browser)
     * @return Success
     */
    downloadZipPackageBrowser(tenantPublicId: string, signFlowId: string, signatureId: string, signatureRequestType: SignatureRequestType, cancelToken?: CancelToken): Promise<void> {
        let url_ = this.baseUrl + "/api/{TenantPublicId}/signflows/v2/{SignFlowId}/{SignatureRequestType}/{SignatureId}/zip/download";
        if (tenantPublicId === undefined || tenantPublicId === null)
            throw new globalThis.Error("The parameter 'tenantPublicId' must be defined.");
        url_ = url_.replace("{TenantPublicId}", encodeURIComponent("" + tenantPublicId));
        if (signFlowId === undefined || signFlowId === null)
            throw new globalThis.Error("The parameter 'signFlowId' must be defined.");
        url_ = url_.replace("{SignFlowId}", encodeURIComponent("" + signFlowId));
        if (signatureId === undefined || signatureId === null)
            throw new globalThis.Error("The parameter 'signatureId' must be defined.");
        url_ = url_.replace("{SignatureId}", encodeURIComponent("" + signatureId));
        if (signatureRequestType === undefined || signatureRequestType === null)
            throw new globalThis.Error("The parameter 'signatureRequestType' must be defined.");
        url_ = url_.replace("{SignatureRequestType}", encodeURIComponent("" + signatureRequestType));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processDownloadZipPackageBrowser(_response);
        });
    }

    protected processDownloadZipPackageBrowser(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status === 400) {
            const _responseText = response.data;
            return throwException("Bad Request", status, _responseText, _headers);

        } else if (status === 401) {
            const _responseText = response.data;
            return throwException("Unauthorized", status, _responseText, _headers);

        } else if (status === 404) {
            const _responseText = response.data;
            return throwException("Not Found", status, _responseText, _headers);

        } else if (status === 419) {
            const _responseText = response.data;
            return throwException("Authorization Timeout", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * Download an attachment
     * @return Success
     */
    downloadAttachmentGET(tenantPublicId: string, signFlowId: string, signatureId: string, signatureRequestType: SignatureRequestType, attachmentId: string, cancelToken?: CancelToken): Promise<FileResponse> {
        let url_ = this.baseUrl + "/api/{TenantPublicId}/signflows/v2/{SignFlowId}/{SignatureRequestType}/{SignatureId}/attachments/{attachmentId}";
        if (tenantPublicId === undefined || tenantPublicId === null)
            throw new globalThis.Error("The parameter 'tenantPublicId' must be defined.");
        url_ = url_.replace("{TenantPublicId}", encodeURIComponent("" + tenantPublicId));
        if (signFlowId === undefined || signFlowId === null)
            throw new globalThis.Error("The parameter 'signFlowId' must be defined.");
        url_ = url_.replace("{SignFlowId}", encodeURIComponent("" + signFlowId));
        if (signatureId === undefined || signatureId === null)
            throw new globalThis.Error("The parameter 'signatureId' must be defined.");
        url_ = url_.replace("{SignatureId}", encodeURIComponent("" + signatureId));
        if (signatureRequestType === undefined || signatureRequestType === null)
            throw new globalThis.Error("The parameter 'signatureRequestType' must be defined.");
        url_ = url_.replace("{SignatureRequestType}", encodeURIComponent("" + signatureRequestType));
        if (attachmentId === undefined || attachmentId === null)
            throw new globalThis.Error("The parameter 'attachmentId' must be defined.");
        url_ = url_.replace("{attachmentId}", encodeURIComponent("" + attachmentId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            responseType: "blob",
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/pdf"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processDownloadAttachmentGET(_response);
        });
    }

    protected processDownloadAttachmentGET(response: AxiosResponse): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers["content-disposition"] : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return Promise.resolve({ fileName: fileName, status: status, data: new Blob([response.data], { type: response.headers["content-type"] }), headers: _headers });
        } else if (status === 400) {
            const _responseText = response.data;
            return throwException("Bad Request", status, _responseText, _headers);

        } else if (status === 401) {
            const _responseText = response.data;
            return throwException("Unauthorized", status, _responseText, _headers);

        } else if (status === 404) {
            const _responseText = response.data;
            return throwException("Not Found", status, _responseText, _headers);

        } else if (status === 419) {
            const _responseText = response.data;
            return throwException("Authorization Timeout", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<FileResponse>(null as any);
    }

    /**
     * Download an attachment
     * @return Success
     */
    downloadAttachmentHEAD(tenantPublicId: string, signFlowId: string, signatureId: string, signatureRequestType: SignatureRequestType, attachmentId: string, cancelToken?: CancelToken): Promise<FileResponse> {
        let url_ = this.baseUrl + "/api/{TenantPublicId}/signflows/v2/{SignFlowId}/{SignatureRequestType}/{SignatureId}/attachments/{attachmentId}";
        if (tenantPublicId === undefined || tenantPublicId === null)
            throw new globalThis.Error("The parameter 'tenantPublicId' must be defined.");
        url_ = url_.replace("{TenantPublicId}", encodeURIComponent("" + tenantPublicId));
        if (signFlowId === undefined || signFlowId === null)
            throw new globalThis.Error("The parameter 'signFlowId' must be defined.");
        url_ = url_.replace("{SignFlowId}", encodeURIComponent("" + signFlowId));
        if (signatureId === undefined || signatureId === null)
            throw new globalThis.Error("The parameter 'signatureId' must be defined.");
        url_ = url_.replace("{SignatureId}", encodeURIComponent("" + signatureId));
        if (signatureRequestType === undefined || signatureRequestType === null)
            throw new globalThis.Error("The parameter 'signatureRequestType' must be defined.");
        url_ = url_.replace("{SignatureRequestType}", encodeURIComponent("" + signatureRequestType));
        if (attachmentId === undefined || attachmentId === null)
            throw new globalThis.Error("The parameter 'attachmentId' must be defined.");
        url_ = url_.replace("{attachmentId}", encodeURIComponent("" + attachmentId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            responseType: "blob",
            method: "HEAD",
            url: url_,
            headers: {
                "Accept": "application/pdf"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processDownloadAttachmentHEAD(_response);
        });
    }

    protected processDownloadAttachmentHEAD(response: AxiosResponse): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers["content-disposition"] : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return Promise.resolve({ fileName: fileName, status: status, data: new Blob([response.data], { type: response.headers["content-type"] }), headers: _headers });
        } else if (status === 400) {
            const _responseText = response.data;
            return throwException("Bad Request", status, _responseText, _headers);

        } else if (status === 401) {
            const _responseText = response.data;
            return throwException("Unauthorized", status, _responseText, _headers);

        } else if (status === 404) {
            const _responseText = response.data;
            return throwException("Not Found", status, _responseText, _headers);

        } else if (status === 419) {
            const _responseText = response.data;
            return throwException("Authorization Timeout", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<FileResponse>(null as any);
    }

    /**
     * Download a SCS flow cover page file
     * @return Success
     */
    downloadScsFlowCoverPageFileGET(tenantPublicId: string, signFlowId: string, signatureId: string, signatureRequestType: SignatureRequestType, scsFlowId: string, cancelToken?: CancelToken): Promise<FileResponse> {
        let url_ = this.baseUrl + "/api/{TenantPublicId}/signflows/v2/{SignFlowId}/{SignatureRequestType}/{SignatureId}/scsflowfiles/{scsFlowId}/coverpage";
        if (tenantPublicId === undefined || tenantPublicId === null)
            throw new globalThis.Error("The parameter 'tenantPublicId' must be defined.");
        url_ = url_.replace("{TenantPublicId}", encodeURIComponent("" + tenantPublicId));
        if (signFlowId === undefined || signFlowId === null)
            throw new globalThis.Error("The parameter 'signFlowId' must be defined.");
        url_ = url_.replace("{SignFlowId}", encodeURIComponent("" + signFlowId));
        if (signatureId === undefined || signatureId === null)
            throw new globalThis.Error("The parameter 'signatureId' must be defined.");
        url_ = url_.replace("{SignatureId}", encodeURIComponent("" + signatureId));
        if (signatureRequestType === undefined || signatureRequestType === null)
            throw new globalThis.Error("The parameter 'signatureRequestType' must be defined.");
        url_ = url_.replace("{SignatureRequestType}", encodeURIComponent("" + signatureRequestType));
        if (scsFlowId === undefined || scsFlowId === null)
            throw new globalThis.Error("The parameter 'scsFlowId' must be defined.");
        url_ = url_.replace("{scsFlowId}", encodeURIComponent("" + scsFlowId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            responseType: "blob",
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/pdf"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processDownloadScsFlowCoverPageFileGET(_response);
        });
    }

    protected processDownloadScsFlowCoverPageFileGET(response: AxiosResponse): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers["content-disposition"] : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return Promise.resolve({ fileName: fileName, status: status, data: new Blob([response.data], { type: response.headers["content-type"] }), headers: _headers });
        } else if (status === 400) {
            const _responseText = response.data;
            return throwException("Bad Request", status, _responseText, _headers);

        } else if (status === 401) {
            const _responseText = response.data;
            return throwException("Unauthorized", status, _responseText, _headers);

        } else if (status === 404) {
            const _responseText = response.data;
            return throwException("Not Found", status, _responseText, _headers);

        } else if (status === 419) {
            const _responseText = response.data;
            return throwException("Authorization Timeout", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<FileResponse>(null as any);
    }

    /**
     * Download a SCS flow cover page file
     * @return Success
     */
    downloadScsFlowCoverPageFileHEAD(tenantPublicId: string, signFlowId: string, signatureId: string, signatureRequestType: SignatureRequestType, scsFlowId: string, cancelToken?: CancelToken): Promise<FileResponse> {
        let url_ = this.baseUrl + "/api/{TenantPublicId}/signflows/v2/{SignFlowId}/{SignatureRequestType}/{SignatureId}/scsflowfiles/{scsFlowId}/coverpage";
        if (tenantPublicId === undefined || tenantPublicId === null)
            throw new globalThis.Error("The parameter 'tenantPublicId' must be defined.");
        url_ = url_.replace("{TenantPublicId}", encodeURIComponent("" + tenantPublicId));
        if (signFlowId === undefined || signFlowId === null)
            throw new globalThis.Error("The parameter 'signFlowId' must be defined.");
        url_ = url_.replace("{SignFlowId}", encodeURIComponent("" + signFlowId));
        if (signatureId === undefined || signatureId === null)
            throw new globalThis.Error("The parameter 'signatureId' must be defined.");
        url_ = url_.replace("{SignatureId}", encodeURIComponent("" + signatureId));
        if (signatureRequestType === undefined || signatureRequestType === null)
            throw new globalThis.Error("The parameter 'signatureRequestType' must be defined.");
        url_ = url_.replace("{SignatureRequestType}", encodeURIComponent("" + signatureRequestType));
        if (scsFlowId === undefined || scsFlowId === null)
            throw new globalThis.Error("The parameter 'scsFlowId' must be defined.");
        url_ = url_.replace("{scsFlowId}", encodeURIComponent("" + scsFlowId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            responseType: "blob",
            method: "HEAD",
            url: url_,
            headers: {
                "Accept": "application/pdf"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processDownloadScsFlowCoverPageFileHEAD(_response);
        });
    }

    protected processDownloadScsFlowCoverPageFileHEAD(response: AxiosResponse): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers["content-disposition"] : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return Promise.resolve({ fileName: fileName, status: status, data: new Blob([response.data], { type: response.headers["content-type"] }), headers: _headers });
        } else if (status === 400) {
            const _responseText = response.data;
            return throwException("Bad Request", status, _responseText, _headers);

        } else if (status === 401) {
            const _responseText = response.data;
            return throwException("Unauthorized", status, _responseText, _headers);

        } else if (status === 404) {
            const _responseText = response.data;
            return throwException("Not Found", status, _responseText, _headers);

        } else if (status === 419) {
            const _responseText = response.data;
            return throwException("Authorization Timeout", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<FileResponse>(null as any);
    }

    /**
     * Download a SCS flow bytes to sign file
     * @return Success
     */
    downloadScsFlowBytesToSignFile(tenantPublicId: string, signFlowId: string, signatureId: string, signatureRequestType: SignatureRequestType, scsFlowId: string, cancelToken?: CancelToken): Promise<FileResponse> {
        let url_ = this.baseUrl + "/api/{TenantPublicId}/signflows/v2/{SignFlowId}/{SignatureRequestType}/{SignatureId}/scsflowfiles/{scsFlowId}/bytestosign";
        if (tenantPublicId === undefined || tenantPublicId === null)
            throw new globalThis.Error("The parameter 'tenantPublicId' must be defined.");
        url_ = url_.replace("{TenantPublicId}", encodeURIComponent("" + tenantPublicId));
        if (signFlowId === undefined || signFlowId === null)
            throw new globalThis.Error("The parameter 'signFlowId' must be defined.");
        url_ = url_.replace("{SignFlowId}", encodeURIComponent("" + signFlowId));
        if (signatureId === undefined || signatureId === null)
            throw new globalThis.Error("The parameter 'signatureId' must be defined.");
        url_ = url_.replace("{SignatureId}", encodeURIComponent("" + signatureId));
        if (signatureRequestType === undefined || signatureRequestType === null)
            throw new globalThis.Error("The parameter 'signatureRequestType' must be defined.");
        url_ = url_.replace("{SignatureRequestType}", encodeURIComponent("" + signatureRequestType));
        if (scsFlowId === undefined || scsFlowId === null)
            throw new globalThis.Error("The parameter 'scsFlowId' must be defined.");
        url_ = url_.replace("{scsFlowId}", encodeURIComponent("" + scsFlowId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            responseType: "blob",
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/octet-stream"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processDownloadScsFlowBytesToSignFile(_response);
        });
    }

    protected processDownloadScsFlowBytesToSignFile(response: AxiosResponse): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers["content-disposition"] : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return Promise.resolve({ fileName: fileName, status: status, data: new Blob([response.data], { type: response.headers["content-type"] }), headers: _headers });
        } else if (status === 400) {
            const _responseText = response.data;
            return throwException("Bad Request", status, _responseText, _headers);

        } else if (status === 401) {
            const _responseText = response.data;
            return throwException("Unauthorized", status, _responseText, _headers);

        } else if (status === 404) {
            const _responseText = response.data;
            return throwException("Not Found", status, _responseText, _headers);

        } else if (status === 419) {
            const _responseText = response.data;
            return throwException("Authorization Timeout", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<FileResponse>(null as any);
    }

    /**
     * Reject a signature
     * @param body (optional) 
     * @return Success
     */
    rejectSignature(tenantPublicId: string, signFlowId: string, signatureId: string, signatureRequestType: SignatureRequestType, body: string | undefined, cancelToken?: CancelToken): Promise<void> {
        let url_ = this.baseUrl + "/api/{TenantPublicId}/signflows/v2/{SignFlowId}/{SignatureRequestType}/{SignatureId}/signatures/reject";
        if (tenantPublicId === undefined || tenantPublicId === null)
            throw new globalThis.Error("The parameter 'tenantPublicId' must be defined.");
        url_ = url_.replace("{TenantPublicId}", encodeURIComponent("" + tenantPublicId));
        if (signFlowId === undefined || signFlowId === null)
            throw new globalThis.Error("The parameter 'signFlowId' must be defined.");
        url_ = url_.replace("{SignFlowId}", encodeURIComponent("" + signFlowId));
        if (signatureId === undefined || signatureId === null)
            throw new globalThis.Error("The parameter 'signatureId' must be defined.");
        url_ = url_.replace("{SignatureId}", encodeURIComponent("" + signatureId));
        if (signatureRequestType === undefined || signatureRequestType === null)
            throw new globalThis.Error("The parameter 'signatureRequestType' must be defined.");
        url_ = url_.replace("{SignatureRequestType}", encodeURIComponent("" + signatureRequestType));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processRejectSignature(_response);
        });
    }

    protected processRejectSignature(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status === 400) {
            const _responseText = response.data;
            return throwException("Bad Request", status, _responseText, _headers);

        } else if (status === 401) {
            const _responseText = response.data;
            return throwException("Unauthorized", status, _responseText, _headers);

        } else if (status === 404) {
            const _responseText = response.data;
            return throwException("Not Found", status, _responseText, _headers);

        } else if (status === 419) {
            const _responseText = response.data;
            return throwException("Authorization Timeout", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * Start Scs (toimikortti) Signature process
     * @return Success
     */
    startScsSignature(signFileId: string, tenantPublicId: string, signFlowId: string, signatureId: string, signatureRequestType: SignatureRequestType, cancelToken?: CancelToken): Promise<string> {
        let url_ = this.baseUrl + "/api/{TenantPublicId}/signflows/v2/{SignFlowId}/{SignatureRequestType}/{SignatureId}/signfiles/{signFileId}/signatures/startscs";
        if (signFileId === undefined || signFileId === null)
            throw new globalThis.Error("The parameter 'signFileId' must be defined.");
        url_ = url_.replace("{signFileId}", encodeURIComponent("" + signFileId));
        if (tenantPublicId === undefined || tenantPublicId === null)
            throw new globalThis.Error("The parameter 'tenantPublicId' must be defined.");
        url_ = url_.replace("{TenantPublicId}", encodeURIComponent("" + tenantPublicId));
        if (signFlowId === undefined || signFlowId === null)
            throw new globalThis.Error("The parameter 'signFlowId' must be defined.");
        url_ = url_.replace("{SignFlowId}", encodeURIComponent("" + signFlowId));
        if (signatureId === undefined || signatureId === null)
            throw new globalThis.Error("The parameter 'signatureId' must be defined.");
        url_ = url_.replace("{SignatureId}", encodeURIComponent("" + signatureId));
        if (signatureRequestType === undefined || signatureRequestType === null)
            throw new globalThis.Error("The parameter 'signatureRequestType' must be defined.");
        url_ = url_.replace("{SignatureRequestType}", encodeURIComponent("" + signatureRequestType));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "POST",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processStartScsSignature(_response);
        });
    }

    protected processStartScsSignature(response: AxiosResponse): Promise<string> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
                result200 = resultData200 !== undefined ? resultData200 : null as any;
    
            return Promise.resolve<string>(result200);

        } else if (status === 400) {
            const _responseText = response.data;
            return throwException("Bad Request", status, _responseText, _headers);

        } else if (status === 401) {
            const _responseText = response.data;
            return throwException("Unauthorized", status, _responseText, _headers);

        } else if (status === 404) {
            const _responseText = response.data;
            return throwException("Not Found", status, _responseText, _headers);

        } else if (status === 419) {
            const _responseText = response.data;
            return throwException("Authorization Timeout", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<string>(null as any);
    }

    /**
     * Mark a signflow signed by one of its signers
     * @return Success
     */
    finishScsSignature(tenantPublicId: string, signFlowId: string, signatureId: string, signatureRequestType: SignatureRequestType, scsFlowId: string, body: Blob, cancelToken?: CancelToken): Promise<void> {
        let url_ = this.baseUrl + "/api/{TenantPublicId}/signflows/v2/{SignFlowId}/{SignatureRequestType}/{SignatureId}/signatures/finishscs/{scsFlowId}";
        if (tenantPublicId === undefined || tenantPublicId === null)
            throw new globalThis.Error("The parameter 'tenantPublicId' must be defined.");
        url_ = url_.replace("{TenantPublicId}", encodeURIComponent("" + tenantPublicId));
        if (signFlowId === undefined || signFlowId === null)
            throw new globalThis.Error("The parameter 'signFlowId' must be defined.");
        url_ = url_.replace("{SignFlowId}", encodeURIComponent("" + signFlowId));
        if (signatureId === undefined || signatureId === null)
            throw new globalThis.Error("The parameter 'signatureId' must be defined.");
        url_ = url_.replace("{SignatureId}", encodeURIComponent("" + signatureId));
        if (signatureRequestType === undefined || signatureRequestType === null)
            throw new globalThis.Error("The parameter 'signatureRequestType' must be defined.");
        url_ = url_.replace("{SignatureRequestType}", encodeURIComponent("" + signatureRequestType));
        if (scsFlowId === undefined || scsFlowId === null)
            throw new globalThis.Error("The parameter 'scsFlowId' must be defined.");
        url_ = url_.replace("{scsFlowId}", encodeURIComponent("" + scsFlowId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = body;

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/octet-stream",
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processFinishScsSignature(_response);
        });
    }

    protected processFinishScsSignature(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status === 400) {
            const _responseText = response.data;
            return throwException("Bad Request", status, _responseText, _headers);

        } else if (status === 401) {
            const _responseText = response.data;
            return throwException("Unauthorized", status, _responseText, _headers);

        } else if (status === 404) {
            const _responseText = response.data;
            return throwException("Not Found", status, _responseText, _headers);

        } else if (status === 419) {
            const _responseText = response.data;
            return throwException("Authorization Timeout", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * Get an SCS flow's status
     * @return Success
     */
    scsStatus(tenantPublicId: string, signFlowId: string, signatureId: string, signatureRequestType: SignatureRequestType, scsFlowId: string, cancelToken?: CancelToken): Promise<ScsFlowStatus> {
        let url_ = this.baseUrl + "/api/{TenantPublicId}/signflows/v2/{SignFlowId}/{SignatureRequestType}/{SignatureId}/signatures/scsstatus/{scsFlowId}";
        if (tenantPublicId === undefined || tenantPublicId === null)
            throw new globalThis.Error("The parameter 'tenantPublicId' must be defined.");
        url_ = url_.replace("{TenantPublicId}", encodeURIComponent("" + tenantPublicId));
        if (signFlowId === undefined || signFlowId === null)
            throw new globalThis.Error("The parameter 'signFlowId' must be defined.");
        url_ = url_.replace("{SignFlowId}", encodeURIComponent("" + signFlowId));
        if (signatureId === undefined || signatureId === null)
            throw new globalThis.Error("The parameter 'signatureId' must be defined.");
        url_ = url_.replace("{SignatureId}", encodeURIComponent("" + signatureId));
        if (signatureRequestType === undefined || signatureRequestType === null)
            throw new globalThis.Error("The parameter 'signatureRequestType' must be defined.");
        url_ = url_.replace("{SignatureRequestType}", encodeURIComponent("" + signatureRequestType));
        if (scsFlowId === undefined || scsFlowId === null)
            throw new globalThis.Error("The parameter 'scsFlowId' must be defined.");
        url_ = url_.replace("{scsFlowId}", encodeURIComponent("" + scsFlowId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processScsStatus(_response);
        });
    }

    protected processScsStatus(response: AxiosResponse): Promise<ScsFlowStatus> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
                result200 = resultData200 !== undefined ? resultData200 : null as any;
    
            return Promise.resolve<ScsFlowStatus>(result200);

        } else if (status === 400) {
            const _responseText = response.data;
            return throwException("Bad Request", status, _responseText, _headers);

        } else if (status === 401) {
            const _responseText = response.data;
            return throwException("Unauthorized", status, _responseText, _headers);

        } else if (status === 404) {
            const _responseText = response.data;
            return throwException("Not Found", status, _responseText, _headers);

        } else if (status === 419) {
            const _responseText = response.data;
            return throwException("Authorization Timeout", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ScsFlowStatus>(null as any);
    }
}

export class ESignCommonClient {
    protected instance: AxiosInstance;
    protected baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        this.instance = instance || axios.create();

        this.baseUrl = baseUrl ?? "";

    }

    /**
     * @return Success
     */
    config(tenantPublicId: string, cancelToken?: CancelToken): Promise<void> {
        let url_ = this.baseUrl + "/api/{TenantPublicId}/Sign/config";
        if (tenantPublicId === undefined || tenantPublicId === null)
            throw new globalThis.Error("The parameter 'tenantPublicId' must be defined.");
        url_ = url_.replace("{TenantPublicId}", encodeURIComponent("" + tenantPublicId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processConfig(_response);
        });
    }

    protected processConfig(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status === 400) {
            const _responseText = response.data;
            return throwException("Bad Request", status, _responseText, _headers);

        } else if (status === 401) {
            const _responseText = response.data;
            return throwException("Unauthorized", status, _responseText, _headers);

        } else if (status === 404) {
            const _responseText = response.data;
            return throwException("Not Found", status, _responseText, _headers);

        } else if (status === 419) {
            const _responseText = response.data;
            return throwException("Authorization Timeout", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * @return Success
     */
    tenantInfoForSignature(tenantPublicId: string, signFlowId: string, signatureId: string, signatureRequestType: SignatureRequestType, cancelToken?: CancelToken): Promise<TenantViewModel> {
        let url_ = this.baseUrl + "/api/{TenantPublicId}/Sign/tenant/{SignFlowId}/{SignatureRequestType}/{SignatureId}";
        if (tenantPublicId === undefined || tenantPublicId === null)
            throw new globalThis.Error("The parameter 'tenantPublicId' must be defined.");
        url_ = url_.replace("{TenantPublicId}", encodeURIComponent("" + tenantPublicId));
        if (signFlowId === undefined || signFlowId === null)
            throw new globalThis.Error("The parameter 'signFlowId' must be defined.");
        url_ = url_.replace("{SignFlowId}", encodeURIComponent("" + signFlowId));
        if (signatureId === undefined || signatureId === null)
            throw new globalThis.Error("The parameter 'signatureId' must be defined.");
        url_ = url_.replace("{SignatureId}", encodeURIComponent("" + signatureId));
        if (signatureRequestType === undefined || signatureRequestType === null)
            throw new globalThis.Error("The parameter 'signatureRequestType' must be defined.");
        url_ = url_.replace("{SignatureRequestType}", encodeURIComponent("" + signatureRequestType));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processTenantInfoForSignature(_response);
        });
    }

    protected processTenantInfoForSignature(response: AxiosResponse): Promise<TenantViewModel> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = TenantViewModel.fromJS(resultData200);
            return Promise.resolve<TenantViewModel>(result200);

        } else if (status === 400) {
            const _responseText = response.data;
            return throwException("Bad Request", status, _responseText, _headers);

        } else if (status === 401) {
            const _responseText = response.data;
            return throwException("Unauthorized", status, _responseText, _headers);

        } else if (status === 404) {
            const _responseText = response.data;
            return throwException("Not Found", status, _responseText, _headers);

        } else if (status === 419) {
            const _responseText = response.data;
            return throwException("Authorization Timeout", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<TenantViewModel>(null as any);
    }

    /**
     * @return Success
     */
    getUserInfo(tenantPublicId: string, cancelToken?: CancelToken): Promise<UserInfo> {
        let url_ = this.baseUrl + "/api/{TenantPublicId}/Sign/userinfo";
        if (tenantPublicId === undefined || tenantPublicId === null)
            throw new globalThis.Error("The parameter 'tenantPublicId' must be defined.");
        url_ = url_.replace("{TenantPublicId}", encodeURIComponent("" + tenantPublicId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetUserInfo(_response);
        });
    }

    protected processGetUserInfo(response: AxiosResponse): Promise<UserInfo> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = UserInfo.fromJS(resultData200);
            return Promise.resolve<UserInfo>(result200);

        } else if (status === 400) {
            const _responseText = response.data;
            return throwException("Bad Request", status, _responseText, _headers);

        } else if (status === 401) {
            const _responseText = response.data;
            return throwException("Unauthorized", status, _responseText, _headers);

        } else if (status === 404) {
            const _responseText = response.data;
            return throwException("Not Found", status, _responseText, _headers);

        } else if (status === 419) {
            const _responseText = response.data;
            return throwException("Authorization Timeout", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<UserInfo>(null as any);
    }

    /**
     * @return Success
     */
    getTenantInfoPageDetails(tenantPublicId: string, cancelToken?: CancelToken): Promise<InfoPageDetails> {
        let url_ = this.baseUrl + "/api/{TenantPublicId}/Sign/tenant/infopagedetails";
        if (tenantPublicId === undefined || tenantPublicId === null)
            throw new globalThis.Error("The parameter 'tenantPublicId' must be defined.");
        url_ = url_.replace("{TenantPublicId}", encodeURIComponent("" + tenantPublicId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetTenantInfoPageDetails(_response);
        });
    }

    protected processGetTenantInfoPageDetails(response: AxiosResponse): Promise<InfoPageDetails> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = InfoPageDetails.fromJS(resultData200);
            return Promise.resolve<InfoPageDetails>(result200);

        } else if (status === 400) {
            const _responseText = response.data;
            return throwException("Bad Request", status, _responseText, _headers);

        } else if (status === 401) {
            const _responseText = response.data;
            return throwException("Unauthorized", status, _responseText, _headers);

        } else if (status === 404) {
            const _responseText = response.data;
            return throwException("Not Found", status, _responseText, _headers);

        } else if (status === 419) {
            const _responseText = response.data;
            return throwException("Authorization Timeout", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<InfoPageDetails>(null as any);
    }

    /**
     * @return Success
     */
    logout(tenantPublicId: string, cancelToken?: CancelToken): Promise<LogoutResult> {
        let url_ = this.baseUrl + "/api/{TenantPublicId}/Sign/logout";
        if (tenantPublicId === undefined || tenantPublicId === null)
            throw new globalThis.Error("The parameter 'tenantPublicId' must be defined.");
        url_ = url_.replace("{TenantPublicId}", encodeURIComponent("" + tenantPublicId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processLogout(_response);
        });
    }

    protected processLogout(response: AxiosResponse): Promise<LogoutResult> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = LogoutResult.fromJS(resultData200);
            return Promise.resolve<LogoutResult>(result200);

        } else if (status === 400) {
            const _responseText = response.data;
            return throwException("Bad Request", status, _responseText, _headers);

        } else if (status === 401) {
            const _responseText = response.data;
            return throwException("Unauthorized", status, _responseText, _headers);

        } else if (status === 404) {
            const _responseText = response.data;
            return throwException("Not Found", status, _responseText, _headers);

        } else if (status === 419) {
            const _responseText = response.data;
            return throwException("Authorization Timeout", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<LogoutResult>(null as any);
    }
}

export class Attachment implements IAttachment {
    id!: string;
    fileName!: string;
    contentType?: string | undefined;

    constructor(data?: IAttachment) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.fileName = _data["fileName"];
            this.contentType = _data["contentType"];
        }
    }

    static fromJS(data: any): Attachment {
        data = typeof data === 'object' ? data : {};
        let result = new Attachment();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["fileName"] = this.fileName;
        data["contentType"] = this.contentType;
        return data;
    }
}

export interface IAttachment {
    id: string;
    fileName: string;
    contentType?: string | undefined;
}

export class AuthenticationMethod implements IAuthenticationMethod {
    displayName?: LocalizedStringIdentity;
    disabledMessage?: string | undefined;
    authenticationType?: string | undefined;
    redirectUrl?: string | undefined;
    id?: string | undefined;
    additionalAuthenticationRequired?: boolean;

    constructor(data?: IAuthenticationMethod) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.displayName = _data["displayName"] ? LocalizedStringIdentity.fromJS(_data["displayName"]) : undefined as any;
            this.disabledMessage = _data["disabledMessage"];
            this.authenticationType = _data["authenticationType"];
            this.redirectUrl = _data["redirectUrl"];
            this.id = _data["id"];
            this.additionalAuthenticationRequired = _data["additionalAuthenticationRequired"];
        }
    }

    static fromJS(data: any): AuthenticationMethod {
        data = typeof data === 'object' ? data : {};
        let result = new AuthenticationMethod();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["displayName"] = this.displayName ? this.displayName.toJSON() : undefined as any;
        data["disabledMessage"] = this.disabledMessage;
        data["authenticationType"] = this.authenticationType;
        data["redirectUrl"] = this.redirectUrl;
        data["id"] = this.id;
        data["additionalAuthenticationRequired"] = this.additionalAuthenticationRequired;
        return data;
    }
}

export interface IAuthenticationMethod {
    displayName?: LocalizedStringIdentity;
    disabledMessage?: string | undefined;
    authenticationType?: string | undefined;
    redirectUrl?: string | undefined;
    id?: string | undefined;
    additionalAuthenticationRequired?: boolean;
}

export class AuthenticationOkResponse implements IAuthenticationOkResponse {
    redirectUrl?: string | undefined;

    constructor(data?: IAuthenticationOkResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.redirectUrl = _data["redirectUrl"];
        }
    }

    static fromJS(data: any): AuthenticationOkResponse {
        data = typeof data === 'object' ? data : {};
        let result = new AuthenticationOkResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["redirectUrl"] = this.redirectUrl;
        return data;
    }
}

export interface IAuthenticationOkResponse {
    redirectUrl?: string | undefined;
}

export enum CodeValidationResult {
    Ok = "Ok",
    InvalidCode = "InvalidCode",
}

export class InfoPageDetails implements IInfoPageDetails {
    privacyPolicyUrl?: string | undefined;
    feedbackUrl?: string | undefined;
    showAccessibilityStatement?: boolean;

    constructor(data?: IInfoPageDetails) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.privacyPolicyUrl = _data["privacyPolicyUrl"];
            this.feedbackUrl = _data["feedbackUrl"];
            this.showAccessibilityStatement = _data["showAccessibilityStatement"];
        }
    }

    static fromJS(data: any): InfoPageDetails {
        data = typeof data === 'object' ? data : {};
        let result = new InfoPageDetails();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["privacyPolicyUrl"] = this.privacyPolicyUrl;
        data["feedbackUrl"] = this.feedbackUrl;
        data["showAccessibilityStatement"] = this.showAccessibilityStatement;
        return data;
    }
}

export interface IInfoPageDetails {
    privacyPolicyUrl?: string | undefined;
    feedbackUrl?: string | undefined;
    showAccessibilityStatement?: boolean;
}

export class LocalizedStringIdentity implements ILocalizedStringIdentity {
    fi?: string | undefined;
    en?: string | undefined;
    sv?: string | undefined;

    constructor(data?: ILocalizedStringIdentity) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.fi = _data["fi"];
            this.en = _data["en"];
            this.sv = _data["sv"];
        }
    }

    static fromJS(data: any): LocalizedStringIdentity {
        data = typeof data === 'object' ? data : {};
        let result = new LocalizedStringIdentity();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["fi"] = this.fi;
        data["en"] = this.en;
        data["sv"] = this.sv;
        return data;
    }
}

export interface ILocalizedStringIdentity {
    fi?: string | undefined;
    en?: string | undefined;
    sv?: string | undefined;
}

export class LogoutResult implements ILogoutResult {
    logoutUrl?: string | undefined;

    constructor(data?: ILogoutResult) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.logoutUrl = _data["logoutUrl"];
        }
    }

    static fromJS(data: any): LogoutResult {
        data = typeof data === 'object' ? data : {};
        let result = new LogoutResult();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["logoutUrl"] = this.logoutUrl;
        return data;
    }
}

export interface ILogoutResult {
    logoutUrl?: string | undefined;
}

export enum OtpType {
    Email = "Email",
    Sms = "Sms",
}

export enum Procuration {
    None = "None",
    Representative = "Representative",
    Authority = "Authority",
}

export enum ScsFlowStatus {
    CoverPageGenerated = "CoverPageGenerated",
    Started = "Started",
    Completed = "Completed",
    Failed = "Failed",
}

export enum SendEmailResultCode {
    Ok = "Ok",
    CannotRetryTooSoon = "CannotRetryTooSoon",
    InvalidSignatureIdOrEmail = "InvalidSignatureIdOrEmail",
    CannotRetryBlocked = "CannotRetryBlocked",
}

export enum SignFileStatus {
    Unsigned = "Unsigned",
    Signed = "Signed",
    SystemSigned = "SystemSigned",
    PersonalSigned = "PersonalSigned",
}

export class SignatureRequest implements ISignatureRequest {
    cancellationComment?: string | undefined;
    signerSignFlowStatus?: SignerSignFlowStatus;
    useScsForSigning?: boolean;
    currentUserIdentifierType?: UserIdentifierType;
    signingRole?: SigningRole;

    constructor(data?: ISignatureRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.cancellationComment = _data["cancellationComment"];
            this.signerSignFlowStatus = _data["signerSignFlowStatus"];
            this.useScsForSigning = _data["useScsForSigning"];
            this.currentUserIdentifierType = _data["currentUserIdentifierType"];
            this.signingRole = _data["signingRole"];
        }
    }

    static fromJS(data: any): SignatureRequest {
        data = typeof data === 'object' ? data : {};
        let result = new SignatureRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["cancellationComment"] = this.cancellationComment;
        data["signerSignFlowStatus"] = this.signerSignFlowStatus;
        data["useScsForSigning"] = this.useScsForSigning;
        data["currentUserIdentifierType"] = this.currentUserIdentifierType;
        data["signingRole"] = this.signingRole;
        return data;
    }
}

export interface ISignatureRequest {
    cancellationComment?: string | undefined;
    signerSignFlowStatus?: SignerSignFlowStatus;
    useScsForSigning?: boolean;
    currentUserIdentifierType?: UserIdentifierType;
    signingRole?: SigningRole;
}

export enum SignatureRequestType {
    Sign = "Sign",
    View = "View",
}

export class SignerDetailsDto implements ISignerDetailsDto {
    name?: string | undefined;
    signingRole?: SigningRole;
    completionTime?: Date | undefined;

    constructor(data?: ISignerDetailsDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            this.signingRole = _data["signingRole"];
            this.completionTime = _data["completionTime"] ? new Date(_data["completionTime"].toString()) : undefined as any;
        }
    }

    static fromJS(data: any): SignerDetailsDto {
        data = typeof data === 'object' ? data : {};
        let result = new SignerDetailsDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["signingRole"] = this.signingRole;
        data["completionTime"] = this.completionTime ? this.completionTime.toISOString() : undefined as any;
        return data;
    }
}

export interface ISignerDetailsDto {
    name?: string | undefined;
    signingRole?: SigningRole;
    completionTime?: Date | undefined;
}

export enum SignerSignFlowStatus {
    NotFound = "NotFound",
    ReadyToSign = "ReadyToSign",
    AlreadySignedAndWaitingForOtherSigners = "AlreadySignedAndWaitingForOtherSigners",
    AlreadySignedAndWaitingForFinalization = "AlreadySignedAndWaitingForFinalization",
    Finalized = "Finalized",
    RejectedBySigner = "RejectedBySigner",
    Cancelled = "Cancelled",
    Failed = "Failed",
    Validating = "Validating",
}

export class SigningInfoDetails implements ISigningInfoDetails {
    inviterName?: string | undefined;
    inviterEmail?: string | undefined;
    signflowName?: string | undefined;
    invitationMessage?: string | undefined;
    organisation?: string | undefined;
    role?: string | undefined;
    signers?: SignerDetailsDto[] | undefined;
    viewers?: ViewerDetailsDto[] | undefined;

    constructor(data?: ISigningInfoDetails) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.inviterName = _data["inviterName"];
            this.inviterEmail = _data["inviterEmail"];
            this.signflowName = _data["signflowName"];
            this.invitationMessage = _data["invitationMessage"];
            this.organisation = _data["organisation"];
            this.role = _data["role"];
            if (Array.isArray(_data["signers"])) {
                this.signers = [] as any;
                for (let item of _data["signers"])
                    this.signers!.push(SignerDetailsDto.fromJS(item));
            }
            if (Array.isArray(_data["viewers"])) {
                this.viewers = [] as any;
                for (let item of _data["viewers"])
                    this.viewers!.push(ViewerDetailsDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): SigningInfoDetails {
        data = typeof data === 'object' ? data : {};
        let result = new SigningInfoDetails();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["inviterName"] = this.inviterName;
        data["inviterEmail"] = this.inviterEmail;
        data["signflowName"] = this.signflowName;
        data["invitationMessage"] = this.invitationMessage;
        data["organisation"] = this.organisation;
        data["role"] = this.role;
        if (Array.isArray(this.signers)) {
            data["signers"] = [];
            for (let item of this.signers)
                data["signers"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.viewers)) {
            data["viewers"] = [];
            for (let item of this.viewers)
                data["viewers"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface ISigningInfoDetails {
    inviterName?: string | undefined;
    inviterEmail?: string | undefined;
    signflowName?: string | undefined;
    invitationMessage?: string | undefined;
    organisation?: string | undefined;
    role?: string | undefined;
    signers?: SignerDetailsDto[] | undefined;
    viewers?: ViewerDetailsDto[] | undefined;
}

export enum SigningRole {
    Signer = "Signer",
    Approver = "Approver",
}

export class TenantViewModel implements ITenantViewModel {
    authenticationUri!: string;
    uiVersion!: number;
    availableLanguages!: string[];
    signFilePolling!: boolean;
    procurationEnabled!: boolean;
    showSigningInfoTab!: boolean;
    signatureRequestExists!: boolean;
    zipFilesAfterFinalization!: boolean;
    isAuthenticated!: boolean;

    constructor(data?: ITenantViewModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
        if (!data) {
            this.availableLanguages = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            this.authenticationUri = _data["authenticationUri"];
            this.uiVersion = _data["uiVersion"];
            if (Array.isArray(_data["availableLanguages"])) {
                this.availableLanguages = [] as any;
                for (let item of _data["availableLanguages"])
                    this.availableLanguages!.push(item);
            }
            this.signFilePolling = _data["signFilePolling"];
            this.procurationEnabled = _data["procurationEnabled"];
            this.showSigningInfoTab = _data["showSigningInfoTab"];
            this.signatureRequestExists = _data["signatureRequestExists"];
            this.zipFilesAfterFinalization = _data["zipFilesAfterFinalization"];
            this.isAuthenticated = _data["isAuthenticated"];
        }
    }

    static fromJS(data: any): TenantViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new TenantViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["authenticationUri"] = this.authenticationUri;
        data["uiVersion"] = this.uiVersion;
        if (Array.isArray(this.availableLanguages)) {
            data["availableLanguages"] = [];
            for (let item of this.availableLanguages)
                data["availableLanguages"].push(item);
        }
        data["signFilePolling"] = this.signFilePolling;
        data["procurationEnabled"] = this.procurationEnabled;
        data["showSigningInfoTab"] = this.showSigningInfoTab;
        data["signatureRequestExists"] = this.signatureRequestExists;
        data["zipFilesAfterFinalization"] = this.zipFilesAfterFinalization;
        data["isAuthenticated"] = this.isAuthenticated;
        return data;
    }
}

export interface ITenantViewModel {
    authenticationUri: string;
    uiVersion: number;
    availableLanguages: string[];
    signFilePolling: boolean;
    procurationEnabled: boolean;
    showSigningInfoTab: boolean;
    signatureRequestExists: boolean;
    zipFilesAfterFinalization: boolean;
    isAuthenticated: boolean;
}

export class UploadSignatureModel implements IUploadSignatureModel {
    proc?: Procuration;

    constructor(data?: IUploadSignatureModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.proc = _data["proc"];
        }
    }

    static fromJS(data: any): UploadSignatureModel {
        data = typeof data === 'object' ? data : {};
        let result = new UploadSignatureModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["proc"] = this.proc;
        return data;
    }
}

export interface IUploadSignatureModel {
    proc?: Procuration;
}

export enum UserIdentifierType {
    Unknown = "Unknown",
    FinnishSSN = "FinnishSSN",
    FinnishElectronicIdentificationNumber = "FinnishElectronicIdentificationNumber",
    Scs = "Scs",
    EidasPersonalIdentifier = "EidasPersonalIdentifier",
    Email = "Email",
    NationalSSN = "NationalSSN",
    PhoneNumber = "PhoneNumber",
    MitIdUuid = "MitIdUuid",
    SwedishSSN = "SwedishSSN",
    NorwegianSSN = "NorwegianSSN",
    FinnishAuthenticatorIdentifier = "FinnishAuthenticatorIdentifier",
}

export class UserInfo implements IUserInfo {
    displayName?: string | undefined;
    userIdentifierType?: UserIdentifierType;
    userIdentifier?: string | undefined;
    readonly loginUrl?: string | undefined;

    constructor(data?: IUserInfo) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.displayName = _data["displayName"];
            this.userIdentifierType = _data["userIdentifierType"];
            this.userIdentifier = _data["userIdentifier"];
            (this as any).loginUrl = _data["loginUrl"];
        }
    }

    static fromJS(data: any): UserInfo {
        data = typeof data === 'object' ? data : {};
        let result = new UserInfo();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["displayName"] = this.displayName;
        data["userIdentifierType"] = this.userIdentifierType;
        data["userIdentifier"] = this.userIdentifier;
        data["loginUrl"] = this.loginUrl;
        return data;
    }
}

export interface IUserInfo {
    displayName?: string | undefined;
    userIdentifierType?: UserIdentifierType;
    userIdentifier?: string | undefined;
    loginUrl?: string | undefined;
}

export class ValidateCodeResponse implements IValidateCodeResponse {
    result?: CodeValidationResult;
    redirectUrl?: string | undefined;

    constructor(data?: IValidateCodeResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.result = _data["result"];
            this.redirectUrl = _data["redirectUrl"];
        }
    }

    static fromJS(data: any): ValidateCodeResponse {
        data = typeof data === 'object' ? data : {};
        let result = new ValidateCodeResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["result"] = this.result;
        data["redirectUrl"] = this.redirectUrl;
        return data;
    }
}

export interface IValidateCodeResponse {
    result?: CodeValidationResult;
    redirectUrl?: string | undefined;
}

export class ViewerDetailsDto implements IViewerDetailsDto {
    name?: string | undefined;

    constructor(data?: IViewerDetailsDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
        }
    }

    static fromJS(data: any): ViewerDetailsDto {
        data = typeof data === 'object' ? data : {};
        let result = new ViewerDetailsDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        return data;
    }
}

export interface IViewerDetailsDto {
    name?: string | undefined;
}

export interface FileParameter {
    data: any;
    fileName: string;
}

export interface FileResponse {
    data: Blob;
    status: number;
    fileName?: string;
    headers?: { [name: string]: any };
}

export class ApiException extends Error {
    message: string;
    status: number;
    response: string;
    headers: { [key: string]: any; };
    result: any;

    constructor(message: string, status: number, response: string, headers: { [key: string]: any; }, result: any) {
        super();

        this.message = message;
        this.status = status;
        this.response = response;
        this.headers = headers;
        this.result = result;
    }

    protected isApiException = true;

    static isApiException(obj: any): obj is ApiException {
        return obj.isApiException === true;
    }
}

function throwException(message: string, status: number, response: string, headers: { [key: string]: any; }, result?: any): any {
    if (result !== null && result !== undefined)
        throw result;
    else
        throw new ApiException(message, status, response, headers, null);
}

function isAxiosError(obj: any): obj is AxiosError {
    return obj && obj.isAxiosError === true;
}
